<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid text-start">
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="d-flex justify-content-between mt-3">
              <p class="fs-5">
                {{ this.$route.meta.title }}
              </p>
            </div>
          </div>

          <div v-if="cart">
            <table
              class="
                table table-responsive table-striped table-hover
                align-middle
              "
            >
              <thead>
                <tr>
                  <th style="width: 40px">#</th>
                  <th>محصول</th>
                  <th>کد</th>
                  <th>تعداد</th>
                  <th>قیمت واحد</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in cart.orderDetail" :key="item.id">
                  <template v-if="item.product.type === 'chairs'">
                    <tr>
                      <td>
                        <a
                          class="border border-secondary btn btn-close btn-sm"
                          @click="deleteProduct(item.id)"
                        ></a>
                      </td>
                      <td>
                        <img
                          style="width: 50px"
                          :src="
                            API_STORAGE_URL + item.product.main_image_thumb_path
                          "
                          @error="noPic"
                        />
                        {{ item.product.name }}
                        <div>
                          <span
                            v-for="(chair, index) in item.productDetails"
                            :key="index"
                            class="
                              btn btn-outline-secondary
                              rounded-pill
                              btn-sm
                              m-1
                            "
                            @click="deleteChairFromCard(chair.id)"
                          >
                            <div class="btn btn-close btn-sm"></div>
                            {{ chair.chair_number }}
                          </span>
                        </div>
                      </td>
                      <td>
                        {{ item.product.id }}
                      </td>
                      <td>
                        {{ item.number }}
                      </td>
                      <td>
                        {{ this.utils.monize(item.price) }}
                        تومان
                      </td>
                    </tr>
                  </template>
                  <template v-else-if="item.all_videos_buy">
                    <tr>
                      <td>
                        <a
                          class="border border-secondary btn btn-close btn-sm"
                          @click="deleteProduct(item.id)"
                        ></a>
                      </td>
                      <td>
                        <img
                          style="width: 50px"
                          :src="
                            API_STORAGE_URL + item.product.main_image_thumb_path
                          "
                          @error="noPic"
                        />
                        {{ item.product.name }} - دوره کامل
                      </td>
                      <td>
                        {{ item.product.id }}
                      </td>
                      <td>
                        {{ item.number }}
                      </td>
                      <td>
                        {{ this.utils.monize(item.price) }}
                        تومان
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <template
                      v-for="itemDetails in item.productDetails"
                      :key="itemDetails.productDetailVideo.id"
                    >
                      <tr>
                        <td>
                          <a
                            class="border border-secondary btn btn-close btn-sm"
                            @click="
                              deleteMicroProduct(
                                item.id,
                                itemDetails.productDetailVideo.id
                              )
                            "
                          ></a>
                        </td>
                        <td>
                          <img
                            style="width: 50px"
                            :src="
                              API_STORAGE_URL +
                              item.product.main_image_thumb_path
                            "
                          />
                          جلسه
                          {{ itemDetails.numName }}
                          -
                          {{ item.product.name }}
                        </td>
                        <td>
                          {{ itemDetails.productDetailVideo.id }}
                        </td>
                        <td>1</td>
                        <td>
                          {{ this.utils.monize(itemDetails.price) }}
                          تومان
                        </td>
                      </tr>
                    </template>
                  </template>
                </template>
              </tbody>
            </table>
            <div class="d-flex">
              <a class="border btn btn-sm text-secondary" @click="emptyCart()">
                <i class="far fa-times-circle"></i>
                حذف تمامی موارد و خالی کردن سبد خرید
              </a>
            </div>
            <div class="row">
              <div class="col">
                <p class="fs-4">کد تخفیف</p>
                <div class="alert alert-danger" v-if="couponError">
                  {{ couponError }}
                </div>
                <div>
                  <label class="m-2"> اگر کد تخفیفی دارید، وارد نمایید </label>
                  <input
                    class="form-control"
                    placeholder="کد تخفیف"
                    v-model="coupon"
                  />

                  <a class="btn btn-primary btn-sm mt-2" @click="setCoupon()">
                    اعمال کد تخفیف
                  </a>
                  <span v-show="couponSpin">
                    <i class="fas fa-spinner fa-spin m-1"></i>
                  </span>
                </div>
              </div>
              <div class="col">
                <p class="fs-4">صورت حساب</p>

                <div>
                  <table class="table table-responsive">
                    <tbody>
                      <tr>
                        <td>مجموع قیمت های محاسبه شده:</td>
                        <td dir="ltr">
                          {{ this.utils.monize(totalPrice) }}
                          تومان
                        </td>
                      </tr>
                      <tr>
                        <td>مجموع تخفیف:</td>
                        <td dir="ltr">
                          {{ this.utils.monize(totalDiscount) }}
                          تومان
                        </td>
                      </tr>
                      <tr>
                        <td>قابل پرداخت:</td>
                        <td dir="ltr">
                          {{ this.utils.monize(cart.amount) }}
                          تومان
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col">
                  <div
                    class="
                      alert alert-card alert-success
                      d-flex
                      justify-content-around
                      fs-4
                    "
                    role="alert"
                  >
                    <span>قابل پرداخت از طریق درگاه:</span>
                    <span>{{ this.utils.monize(cart.amount) }} تومان</span>
                    <div>
                      <a class="btn btn-success" @click="completeBuying()"
                        >تایید نهایی خرید</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <span v-show="showSpin">
              <i class="fas fa-spinner fa-spin fs-1 mt-3"></i>
            </span>
            {{ emptyCardMsg }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheSidemenu from "../../components/TheSidemenu";
import TheTopmenu from "../../components/TheTopmenu";
import ArefApi from "../../libs/api.js";
import utils from "../../libs/utils";

export default {
  name: "Cart",
  created() {
    this.arefApi = new ArefApi(this);
    this.utils = new utils();
    this.getCart();
    this.API_STORAGE_URL = process.env.VUE_APP_API_STORAGE_URL;
  },
  components: {
    TheSidemenu,
    TheTopmenu,
  },
  data() {
    return {
      cart: null,
      showSpin: true,
      couponSpin: false,
      emptyCardMsg: null,
      coupon: null,
      couponError: null,
    };
  },
  methods: {
    getCart() {
      this.arefApi
        .getCart()
        .then((resp) => {
          this.cart = resp.data;
          if (resp.data.length == 0 || resp.data.orderDetail.length == 0) {
            this.cart = null;
            this.emptyCardMsg = "سبد خرید شما خالی می باشد";
            this.showSpin = false;
          }
          this.$store.commit("set", [
            "cartCount",
            this.utils.getCartCount(resp.data),
          ]);
          this.$store.commit("set", ["cartAmount", resp.data.amount]);
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    deleteProduct(order_details_id) {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .deleteProductFromCart(order_details_id)
              .then((resp) => {
                this.cart = resp.data;
                if (
                  resp.data.length == 0 ||
                  resp.data.orderDetail.length == 0
                ) {
                  this.cart = null;
                  this.emptyCardMsg = "سبد خرید شما خالی می باشد";
                  this.showSpin = false;
                }
                this.utils.showSuccess(this);
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
    deleteMicroProduct(order_details_id, product_detals_id) {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .deleteMicroProductFromCart(order_details_id, product_detals_id)
              .then((resp) => {
                this.cart = resp.data;
                if (
                  resp.data.length == 0 ||
                  resp.data.orderDetail.length == 0
                ) {
                  this.cart = null;
                  this.emptyCardMsg = "سبد خرید شما خالی می باشد";
                  this.showSpin = false;
                }
                this.utils.showSuccess(this);
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
    emptyCart() {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .emptyCart()
              .then(() => {
                this.cart = null;
                this.emptyCardMsg = "سبد خرید شما خالی می باشد";
                this.showSpin = false;
                this.utils.showSuccess(this);
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
    setCoupon() {
      this.couponError = null;
      if (!this.coupon) {
        this.couponError = "لطفا کد تخفیف را وارد نمایید";
        return;
      }
      const couponData = {
        coupons_name: this.coupon,
      };
      this.couponSpin = true;
      this.arefApi
        .addCouponToCart(couponData)
        .then((resp) => {
          this.cart = resp.data;
          this.utils.showSuccess(this, "کد تخفیف با موفقیت اعمال شد");
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        })
        .finally(() => {
          this.couponSpin = false;
        });
    },
    completeBuying() {
      this.$swal
        .fire({
          title: "پرداخت",
          text: "آیا از تایید فاکتور اطمینان دارید؟",
          icon: "success",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText:
            this.cart.amount == 0 ? "بله" : "بله و هدایت به درگاه بانکی",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .completeBuying()
              .then((resp) => {
                console.log({resp});
                if (resp["startpay"]) {
                  // zarinpal checkout
                  window.location = resp.startpay;
                  return;
                }

                if (resp.data.order_status == "ok") {
                  this.$store.commit("set", ["cartAmount", 0]);
                  this.$store.commit("set", ["cartCount", 0]);
                  this.utils.showSuccess(this, "خرید با موفقیت انجام شد");
                  this.$router.push({ name: "Home" });
                } else {
                  if (Number(resp.data.res_code) == 0) {
                    this.postRefId(resp.data.ref_id);
                  } else {
                    this.$swal.fire({
                      title: "!خطا",
                      text: `خطا در ارتباط با بانک`,
                      icon: "error",
                      confirmButtonText: "متوجه شدم",
                    });
                  }
                }
              })
              .catch((err) => {
                if (err.data.errors && err.data.errors.bank_error) {
                  this.$swal.fire({
                    title: "!خطا",
                    text: this.utils.traslate(err.data.errors.bank_error),
                    icon: "error",
                    confirmButtonText: "متوجه شدم",
                  });
                }
              });
          }
        });
    },
    postRefId(ref_id) {
      const form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", process.env.VUE_APP_MELLATPAYPAGE);
      form.setAttribute("target", "_self");
      const hiddenField = document.createElement("input");
      hiddenField.setAttribute("name", "RefId");
      hiddenField.setAttribute("value", ref_id);
      form.appendChild(hiddenField);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
    noPic(e) {
      e.target.src =
        process.env.VUE_APP_API_STORAGE_URL + process.env.VUE_APP_NO_IMAGE_URL;
    },
    deleteChairFromCard(chairId) {
      this.arefApi
        .deleteChairFromCard(chairId)
        .then(() => {
          this.utils.showSuccess(this, "حذف با موفقیت انجام شد");
          this.getCart();
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
  },
  computed: {
    totalDiscount: function () {
      if (!this.cart || !this.cart.orderDetail) {
        return 0;
      }
      return this.cart.orderDetail.reduce(function (totalDiscount, item) {
        return (
          totalDiscount + (item.total_price - item.total_price_with_coupon)
        );
      }, 0);
    },
    totalPrice: function () {
      if (!this.cart || !this.cart.orderDetail) {
        return 0;
      }
      return this.cart.orderDetail.reduce(function (totalPrice, item) {
        return totalPrice + item.total_price;
      }, 0);
    },
  },
  watch: {
    cart: function (newVal) {
      if (newVal) {
        this.$store.commit("set", ["cartAmount", newVal.amount]);
        this.$store.commit("set", [
          "cartCount",
          this.utils.getCartCount(newVal),
        ]);
      } else {
        this.$store.commit("set", ["cartAmount", 0]);
        this.$store.commit("set", ["cartCount", 0]);
      }
    },
  },
};
</script>

